import { defaultConfig } from './config'

export function formatCurrency(value, currency = defaultConfig.currency) {
    const formats = {
        EUR: () => {
            return `${new Intl.NumberFormat('lt-LT', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} €`
        },
        USD: () => {
            return `$ ${new Intl.NumberFormat('en-US', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `${value} ${currency}`
}

export function formatDate(date) {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    })
}

export const getLowestPricedSku = (skus) => {
    let lowestOnSale = null;
  
    skus.forEach(sku => {
        if (sku.listPrice > sku.price && (!lowestOnSale || sku.price < lowestOnSale.price)) {
            lowestOnSale = sku;
        }
    });
  
    return lowestOnSale;
};

export const urlsToExclude = [
    'https://www.harney.com/collections/white-tea',
    'https://www.harney.com/collections/chinese-green-tea',
    'https://www.harney.com/collections/flavored-green-tea',
    'https://www.harney.com/collections/green-tea-from-other-regions',
    'https://www.harney.com/collections/japanese-green-tea',
    'https://www.harney.com/collections/chinese-oolong-tea',
    'https://www.harney.com/collections/flavored-oolong-tea',
    'https://www.harney.com/collections/taiwanese-oolong-tea',
    'https://www.harney.com/collections/black-tea',
    'https://www.harney.com/collections/flavored-black-tea',
    'https://www.harney.com/collections/assam-black-tea',
    'https://www.harney.com/collections/black-tea-blends',
    'https://www.harney.com/collections/ceylon-black-tea',
    'https://www.harney.com/collections/chinese-black-tea',
    'https://www.harney.com/collections/darjeeling-teas',
    'https://www.harney.com/collections/decaf-black-tea',
    'https://www.harney.com/collections/pu-erhs',
    'https://www.harney.com/collections/teas-from-other-regions',
    'https://www.harney.com/collections/herbal-blends',
    'https://www.harney.com/collections/fruit-tea',
    'https://www.harney.com/collections/rooibos',
    'https://www.harney.com/collections/herbs-native-to-the-americas',
    'https://www.harney.com/collections/tisanes',
    'https://www.harney.com/collections/all-herbal-infusions',
    'https://www.harney.com/collections/jasmine-tea',
    'https://www.harney.com/collections/decaffeinated-tea'
]